export const datasMapStatus = {
  RETRIEVE_DATAS_MAP_STATUS: "RETRIEVE_DATAS_MAP_STATUS",
};
